import React, { FC } from 'react';
import { v4 as uuid } from 'uuid';

import { Skeleton } from 'esa-ui-library';
import styles from './GamesReportTable.module.scss';

interface SkeletonRowProps {
	cells: string[];
}

const SkeletonRow: FC<SkeletonRowProps> = ({ cells }): JSX.Element => (
	<tr data-testid='skeleton-row' className={`${styles.TableRow}}`}>
		{cells.map(() => (
			<td key={uuid()} className={styles.SkeletonCell}>
				<Skeleton variant='rounded' animation='wave' width='95%' height={25} />
			</td>
		))}
	</tr>
);

export { SkeletonRow };
